/**
 * Validates SID.
 * @param {String} sid - SID to be validated.
 * @return {Boolean} True if valid, false otherwise.
 */
const isValid = (sid) => {
  // SID format described here:
  // https://gitlab.seznam.net/datacollect/datacollect-nginx-modules/-/tree/master/ap_mod#sid-cookie-format
  const regex = /^id=[0-9]+\|t=[0-9]+.[0-9]+\|te=[0-9]+.[0-9]+(\|opt-out=True)?\|c=[0-9A-Z]+$/;
  const res = regex.test(sid);
  return res;
};

export { isValid };
